/** Canonical, allowlisted embeds for both drafts and published content. */
export function safeEmbedVideoUrl(value: string | null | undefined): string | null {
  const input = value?.trim();
  if (!input || input.includes("\\")) return null;

  // Reject credentials, ports, backslashes, and alternate schemes before URL normalization.
  const authority = /^https:\/\/([^/?#]+)/.exec(input)?.[1];
  if (!authority || !/^[a-zA-Z0-9.-]+$/.test(authority)) return null;

  let url: URL;
  try { url = new URL(input); } catch { return null; }

  const host = url.hostname.toLowerCase();
  let youtubeId: string | null = null;
  if (host === "youtu.be") youtubeId = url.pathname.slice(1);
  if (["youtube.com", "www.youtube.com", "m.youtube.com"].includes(host)) {
    youtubeId = url.pathname === "/watch" ? url.searchParams.get("v") : /^\/(?:embed|shorts)\/([A-Za-z0-9_-]{11})$/.exec(url.pathname)?.[1] ?? null;
  }
  if (host === "www.youtube-nocookie.com") youtubeId = /^\/embed\/([A-Za-z0-9_-]{11})$/.exec(url.pathname)?.[1] ?? null;
  if (youtubeId && /^[A-Za-z0-9_-]{11}$/.test(youtubeId)) return `https://www.youtube-nocookie.com/embed/${youtubeId}`;

  if (["vimeo.com", "www.vimeo.com", "player.vimeo.com"].includes(host)) {
    const vimeoId = /^\/(?:video\/)?([0-9]+)$/.exec(url.pathname)?.[1];
    if (vimeoId) return `https://player.vimeo.com/video/${vimeoId}`;
  }
  return null;
}
